<template>
    <div>
        <div class="mb-6">
            <h6 class="has-text-grey is-uppercase">Checkpoint Title</h6>
            <b-field>
                <b-input size="is-large" expanded v-model="component.title" />
            </b-field>
            <h6 class="has-text-grey is-uppercase">Type</h6>
            <b-field>
                <b-select size="is-large" expanded v-model="component.content.attributes.type">
                    <option value="ReflectionCheckpoint">Reflection/Open Question</option>
                    <option value="MultiChoiceCheckpoint">Multiple Choice Question</option>
                    <option value="SingleChoiceCheckpoint">Single Choice Question</option>
                    <option value="TextMatchCheckpoint">Text Matching Question</option>
                </b-select>
            </b-field>
        </div>

        <component :is="component.content.attributes.type" :component="component" />
    </div>

</template>

<script>
    import ReflectionCheckpoint from "../checkpoint_types/ReflectionCheckpoint.vue";
    import MultiChoiceCheckpoint from "../checkpoint_types/MultiChoiceCheckpoint.vue";
    import SingleChoiceCheckpoint from "../checkpoint_types/SingleChoiceCheckpoint.vue";
    import TextMatchCheckpoint from "../checkpoint_types/TextMatchCheckpoint.vue";

    export default {
        components: {ReflectionCheckpoint, MultiChoiceCheckpoint, SingleChoiceCheckpoint, TextMatchCheckpoint},
        props: ['component'],
        data: function () {
            return {
                content: {}
            };
        }
    };
</script>

<style lang="scss" scoped>
    .collapse-header {
        border-bottom: 2px solid #e7e7e7;
        padding-bottom: 0;
        margin-bottom: 20px;

        i {
            padding: 0 10px;
        }
    }
</style>
